<label class="dx-field-item-label dx-field-item-label-location-top" for="for">
  <span class="dx-field-item-label-content">
    <span class="dx-field-item-label-text">{{text}}</span>
  </span>
</label>
